import { get } from './index';

export const getEntityHistory = ({
  entityType,
  entityId,
  page = 1,
  perPage = 20,
}) => {
  const limit = perPage;
  const offset = (page - 1) * perPage;
  return get(
    `/entity-history/${entityType}/${entityId}?limit=${limit}&offset=${offset}`,
  );
};
